import {
  IPropertyConfigurationInput,
  PropertyType,
} from '~/client/graph/types.generated'
import { ResourceProperty } from '~/client/src/desktop/views/ProjectSetUp/components/ProjectSetupResourceConfig/ResourceProperties/types'
import {
  DEFAULT_RESOURCE_LINK_TARGET,
  getResourceLinkTarget,
} from '~/client/src/shared/resources/resourceLink'

export interface BuildPropertyPreviewDraftInput {
  propertyData: ResourceProperty | null
  label: string
  name: string
  propertyType: PropertyType
  configuration: unknown
  resourceTypeId?: string
  position: number
}

export function getPropertyConfigurationWithDefaults(
  type: PropertyType,
  current: any,
): IPropertyConfigurationInput | undefined {
  switch (type) {
    case PropertyType.Select:
    case PropertyType.Hierarchy:
    case PropertyType.Text:
    case PropertyType.File:
      return current
    case PropertyType.User:
      return {
        importExport: {
          entityType: 'user',
          exportField: 'email',
          importField: 'email',
        },
      }
    case PropertyType.Company:
      return {
        importExport: {
          entityType: 'company',
          exportField: 'name',
          importField: 'name',
        },
      }
    case PropertyType.ResourceLink: {
      const targetResourceType =
        current?.resourceLink?.targetResourceType ??
        DEFAULT_RESOURCE_LINK_TARGET
      const target = getResourceLinkTarget({
        resourceLink: { targetResourceType },
      })
      return {
        resourceLink: { targetResourceType },
        ...(target?.defaultPropertyConfig() ?? {}),
      }
    }
    default:
      return undefined
  }
}

export function buildPropertyPreviewDraft({
  propertyData,
  label,
  name,
  propertyType,
  configuration,
  resourceTypeId,
  position,
}: BuildPropertyPreviewDraftInput): ResourceProperty | null {
  const displayName = label.trim()
  const propertyName = name.trim()

  if (!displayName || !propertyName || !propertyType || !resourceTypeId) {
    return null
  }

  return {
    id: propertyData?.id ?? null,
    resourceTypeId,
    isExternal: propertyData?.isExternal ?? false,
    isArchived: propertyData?.isArchived ?? false,
    createdBy: propertyData?.createdBy,
    name: propertyName,
    displayName,
    propertyType,
    position: propertyData?.position ?? position,
    updatedAt: propertyData?.updatedAt ?? null,
    configuration: (getPropertyConfigurationWithDefaults(
      propertyType,
      configuration,
    ) ??
      configuration ??
      {}) as ResourceProperty['configuration'],
  }
}
